<template>
  <div class="verify-code-container" >
		</el-input>
    <!-- 验证码画布 -->
    <canvas
      ref="verifyCanvas"
      width="120"
      height="40"
      class="verify-canvas"
			@click="refreshCode"
    ></canvas>
  </div>
</template>

<script>
export default {
  name: "VerifyCode",
  data() {
    return {
      // 存储当前验证码（用于后续验证）
      code: "",
      // 验证码字符库（数字+大小写字母）
      codeChars: "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz",
    };
  },
  mounted() {
    // 组件挂载后生成初始验证码
    this.drawCode();
  },
  methods: {
    /**
     * 绘制验证码（核心方法）
     */
    drawCode() {
      // 获取画布上下文
      const canvas = this.$refs.verifyCanvas;
      const ctx = canvas.getContext("2d");
      // 清空画布（避免刷新时叠加）
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      // 1. 绘制背景（浅灰色渐变）
      const bgGradient = ctx.createLinearGradient(0, 0, canvas.width, 0);
      bgGradient.addColorStop(0, "#f8f8f8");
      bgGradient.addColorStop(1, "#e8e8e8");
      ctx.fillStyle = bgGradient;
      ctx.fillRect(0, 0, canvas.width, canvas.height);

      // 2. 生成随机验证码（4位）
      this.code = "";
      for (let i = 0; i < 4; i++) {
        this.code += this.codeChars[Math.floor(Math.random() * this.codeChars.length)];
      }

      // 3. 绘制验证码文字（随机颜色、大小、偏移）
      ctx.font = "bold 20px Arial"; // 字体样式
      for (let i = 0; i < this.code.length; i++) {
        // 随机文字颜色（深色系，避免和背景融合）
        ctx.fillStyle = `rgb(${30 + Math.random() * 100}, ${30 + Math.random() * 100}, ${30 + Math.random() * 100})`;
        // 随机文字位置（x轴偏移，y轴居中）
        const x = 15 + i * 25 + Math.random() * 10;
        const y = canvas.height / 2 + Math.random() * 10 + 5;
        // 随机旋转角度（-30° ~ 30°）
        ctx.save();
        ctx.translate(x, y);
        ctx.rotate((Math.random() * 60 - 30) * Math.PI / 180);
        // 绘制单个字符
        ctx.fillText(this.code[i], 0, 0);
        ctx.restore();
      }

      // 4. 绘制干扰线（5条）
      for (let i = 0; i < 5; i++) {
        ctx.beginPath();
        ctx.strokeStyle = `rgb(${100 + Math.random() * 100}, ${100 + Math.random() * 100}, ${100 + Math.random() * 100})`;
        ctx.lineWidth = 1;
        // 随机起点和终点
        ctx.moveTo(Math.random() * canvas.width, Math.random() * canvas.height);
        ctx.lineTo(Math.random() * canvas.width, Math.random() * canvas.height);
        ctx.stroke();
      }

      // 5. 绘制干扰点（50个）
      for (let i = 0; i < 50; i++) {
        ctx.beginPath();
        ctx.fillStyle = `rgb(${80 + Math.random() * 120}, ${80 + Math.random() * 120}, ${80 + Math.random() * 120})`;
        ctx.arc(
          Math.random() * canvas.width,
          Math.random() * canvas.height,
          0.5, // 点的半径
          0,
          2 * Math.PI
        );
        ctx.fill();
      }
    },

    /**
     * 刷新验证码
     */
    refreshCode() {
      this.drawCode();
    },

    /**
     * 对外暴露验证方法（供父组件调用）
     * @param {String} inputCode 用户输入的验证码
     * @returns {Boolean} 验证结果
     */
    validateCode(inputCode) {
      // 忽略大小写验证
      return inputCode.toUpperCase() === this.code.toUpperCase();
    },
  },
};
</script>

<style scoped>
.verify-code-container {
  display: inline-flex;
  align-items: center;
  cursor: pointer;
}
.el-input {
	width: 160px;
	margin-right: 10px;
}
.verify-canvas {
  border: 1px solid #e5e5e5;
  border-radius: 4px;
}

.refresh-tip {
  font-size: 12px;
  color: #999;
  margin-left: 8px;
  user-select: none;
}
</style>